<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <yw-intelligent-patrol-plan-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></yw-intelligent-patrol-plan-form>
  </j-modal>
</template>

<script>

  import YwIntelligentPatrolPlanForm from './YwIntelligentPatrolPlanForm'
  export default {
    name: 'YwIntelligentPatrolPlanModal',
    components: {
      YwIntelligentPatrolPlanForm
    },
    data () {
      return {
        title:'',
        width:936,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>